export default __webpack_public_path__ + "static/media/cover6.f3e059a2.jpeg";